import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Desktop from './components/Desktop';
import Dashboard from './components/Dashboard';
import Principals from './components/Principals';
// import { RegisterPage } from './components/RegisterPage';
// import { VerifyEmailPage } from './components/VerifyEmailPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-gray-900">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 rounded-full border-2 border-white/20 border-t-white animate-spin" />
          <span className="text-white/60 text-sm font-medium">Loading KAELO...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/principals" element={<Principals />} />
          {/* <Route path="/register" element={<RegisterPage />} /> */}
          {/* <Route path="/verify-email" element={<VerifyEmailPage />} /> */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Desktop />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
